import axios from 'axios';

const registrationStore = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    async searchRegistration(context, data) {
      return axios.get(
        `${window.BASE_API.REGISTRATION_USERS}/optIn/${data.email}`,
      )
        .then(response => response.data)
        .catch(error => Promise.reject(error));
    },
    async deleteRegistration(context, data) {
      return axios.delete(
        `${window.BASE_API.REGISTRATION_USERS}/optIn/${data.email}`,
      )
        .then(response => response.data)
        .catch(error => Promise.reject(error));
    },
  },
};

export default registrationStore;



// WEBPACK FOOTER //
// ./src/store/users/registrationStore.js